import React, { useState, useEffect } from 'react'
import { TextField } from '@mui/material'
import { useField, useFormikContext } from 'formik'
import _ from 'lodash'

const LNG_LAT_FIELDS = ['longX', 'latY']

const TextfieldWrapper = ({
  name,
  variant = 'outlined',
  InputProps,
  icon_,
  chip,
  ...rest
}) => {
  const [field, meta] = useField(name)
  const [hasUserInput, setHasUserInput] = useState(false)
  const { setFieldValue } = useFormikContext()

  const handleOnChange = event => {
    const { value } = event.target
    if (_.includes(LNG_LAT_FIELDS, name)) {
      setHasUserInput(true) // Marcar que el usuario ha interactuado
    }
    setFieldValue(name, value)
  }

  let configTextfield = {
    ...field,
    ...rest,
    InputProps: {
      ...InputProps,
      ...icon_,
    },
    variant,
  }

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true
    configTextfield.helperText = meta.error
  }

  // 🔥 LÓGICA CORREGIDA PARA CAMPOS DE COORDENADAS
  if (_.includes(LNG_LAT_FIELDS, name)) {
    configTextfield = {
      ...configTextfield,
      onChange: handleOnChange,

      // 🎯 NUEVA LÓGICA: Mostrar field.value si existe, sino rest.initvalue
      value:
        field.value !== undefined && field.value !== ''
          ? field.value
          : rest.initvalue || '',
    }
  }

  // 🎯 DETECTAR cuando Formik actualiza el valor programáticamente
  useEffect(() => {
    if (!_.includes(LNG_LAT_FIELDS, name)) return

    // Si field.value cambió y no fue por input del usuario, es una actualización automática
    if (field.value && field.value !== '' && !hasUserInput) {
      // Actualización automática desde el mapa - no necesitamos hacer nada
    }
  }, [field.value, name, hasUserInput])

  // 🎯 RESETEAR cuando rest.initvalue cambie (mantener funcionalidad original)
  useEffect(() => {
    if (!_.includes(LNG_LAT_FIELDS, name)) return

    // Solo resetear si no hay valor en field.value
    if (!field.value || field.value === '') {
      setHasUserInput(false)
    }
  }, [rest.initvalue, field.value, name])

  return (
    <TextField
      {...configTextfield}
      fullWidth={rest.fullWidth !== undefined ? rest.fullWidth : true}
      sx={{
        width: rest.sx?.width,
        '& .MuiInputBase-input': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        ...rest.sx,
      }}
    />
  )
}

export default React.memo(TextfieldWrapper)
